<template>
  <div class="word-list2">
    <div
      class="head"
      :style="{
        backgroundImage: 'url(' + dataInfo.cover + ')'
      }"
    >
      {{ dataInfo.name }}
    </div>
    <div class="g-box">
      <div class="content">
        <div
          class="item"
          :class="i % 2 ? 'reserve' : ''"
          v-for="(item, i) in dataList"
          :key="item.id"
          :style="{
            backgroundImage: 'url(' + item.image + ')'
          }"
        >
          <div class="title">{{ item.title }}</div>
          <div class="subtitle" v-html="item.tips"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";

export default {
  data() {
    return {
      query: this.$route.query,
      dataInfo: {},
      dataList: []
    };
  },
  mixins: [pageMain_mx],
  components: {},
  mounted() {},
  methods: {
    async init() {
      const data = await this.getMenuList({
        pageNum: 1,
        pageSize: 999,
        menuId: this.query.id
      });
      this.dataList = data;
      const dataInfo = await this.getMenuInfo(this.query.id);
      this.dataInfo = dataInfo;
    }
  }
};
</script>
<style lang="less">
.word-list2 {
  .head {
    height: 280px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 60px;
    color: #fff;
    letter-spacing: 40px;
  }
  .content {
    padding-top: 80px;
    padding-bottom: 110px;
    .item {
      margin-bottom: 60px;
      padding: 70px 140px;
      display: flex;
      flex-direction: column;
      height: 340px;
      width: 1200px;
      box-sizing: border-box;
      background-size: 100% 100%;
      .title {
        font-size: 48px;
        font-weight: 500;
        color: #fff;
      }
      .subtitle {
        padding-top: 30px;
        font-size: 28px;
        color: #fff;
        letter-spacing: 2px;
      }
    }
    .item.reserve {
      align-items: flex-end;
    }
    .item:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
